import request from '@/utils/request'


// 查询师傅信用分列表
export function listCreditScore(query) {
  return request({
    url: '/master/master-credit-score/list',
    method: 'get',
    params: query
  })
}

// 查询师傅信用分分页
export function pageCreditScore(query) {
  return request({
    url: '/master/master-credit-score/page',
    method: 'get',
    params: query
  })
}

// 查询师傅信用分详细
export function getCreditScore(data) {
  return request({
    url: '/master/master-credit-score/detail',
    method: 'get',
    params: data
  })
}

// 新增师傅信用分
export function addCreditScore(data) {
  return request({
    url: '/master/master-credit-score/add',
    method: 'post',
    data: data
  })
}

// 修改师傅信用分
export function updateCreditScore(data) {
  return request({
    url: '/master/master-credit-score/edit',
    method: 'post',
    data: data
  })
}

// 删除师傅信用分
export function delCreditScore(data) {
  return request({
    url: '/master/master-credit-score/delete',
    method: 'post',
    data: data
  })
}
